import { useEffect, useState } from "react";
import { MDBCard, MDBCol, MDBContainer, MDBRow, MDBCardImage, MDBListGroup, MDBListGroupItem, MDBCardGroup, MDBIcon, MDBBtn } from "mdb-react-ui-kit";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import Json from "./output.json";

export default function Tienda() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
    const [datos, setDatos] = useState([]);
    const params = useParams();

    useEffect(() => {
        // Simulando una carga asíncrona
        // Reemplaza esto con tu lógica de carga de datos real
        // Ejemplo: const response = await fetch("ruta/del/archivo/output.json");
        // const data = await response.json();
        const data = Json; // Simulación de datos, reemplázalo con tu lógica real
        setDatos(Object.values(data));
        //console.log(datos[params.Id])
    }, [params.Id]); // Asegúrate de incluir params.Id en las dependencias del useEffect

    if (!datos[params.Id] || !params.Id) {
        return <div>Cargando datos...</div>;
    }
    return (
        <>
            <MDBContainer className="mt-5">
                <MDBRow>
                    <MDBCol lg={4}>
                        <MDBCard>
                            {<VewImagen />}
                            <div className="vr vr-blurry" style={{ height: '10px' }}></div>
                            <section class="text-center">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6 mb-5 mb-md-5 mb-lg-0 position-relative">
                                        <i className="fas fa-cubes fa-3x text-primary mb-4"></i>
                                        <h5 className="text-primary fw-bold mb-3">5000+</h5>
                                        <div className="vr vr-blurry position-absolute my-0 h-100 d-none d-md-block top-0 end-0"></div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-5 mb-md-5 mb-lg-0 position-relative">
                                        <i className="fas fa-layer-group fa-3x text-primary mb-4"></i>
                                        <h5 className="text-primary fw-bold mb-3">490+</h5>
                                        <div className="vr vr-blurry position-absolute my-0 h-100 d-none d-md-block top-0 end-0"></div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-5 mb-md-0 position-relative">
                                        <i className="fas fa-image fa-3x text-primary mb-4"></i>
                                        <h5 className="text-primary fw-bold mb-3">100+</h5>
                                        <div className="vr vr-blurry position-absolute my-0 h-100 d-none d-md-block top-0 end-0"></div>
                                    </div>

                                    <div className="col-lg-3 col-md-6 mb-5 mb-md-0 position-relative">
                                        <i className="fas fa-plug fa-3x text-primary mb-4"></i>
                                        <h5 className="text-primary fw-bold mb-3">28</h5>
                                    </div>
                                </div>
                            </section>
                        </MDBCard>
                    </MDBCol>
                    <MDBCol lg={8} >
                        <MDBCard className="p-4">
                            <h1>{datos[params.Id].Titulo}</h1>
                            <div className="mt-2 text-break">
                                {datos[params.Id].Descripcion}.
                            </div>
                            <div className="mt-2">
                                {datos[params.Id].Informacion_Adicional}.
                            </div>
                            <div className="mt-2">
                                <h1 className="fs-5 fw-bold">Precio</h1>
                                <p className="fs-2 fw-bold">$ {datos[params.Id].Precio}</p>
                            </div>
                            <div>
                            <div className="fs-6 fw-bold"> Ingredientes</div>
                                {
                                    <MDBCardGroup >
                                        {Object.keys(datos[params.Id].Mezcla).map((key, index) => (
                                            <MDBCard className='d-flex justify-content-between align-items-center' key={index}>
                                                {datos[params.Id].Mezcla[key]}
                                            </MDBCard>
                                        ))}
                                    </MDBCardGroup>
                                }
                            </div>
                            <div>
                                <div className="fs-6 fw-bold">
                                    Tipos :
                                </div>
                                {
                                    <MDBListGroup>
                                        {Object.keys(datos[params.Id].Precios).map((tipo, indexTipo) => (
                                            <MDBListGroupItem key={indexTipo}>
                                                <MDBIcon icon='long-arrow-alt-right' className='me-2 text-info' />
                                                <strong>{tipo}</strong>
                                                <MDBListGroup>
                                                    {Object.keys(datos[params.Id].Precios[tipo]).map((cantidad, indexCantidad) => (
                                                        <MDBListGroupItem key={indexCantidad}>
                                                            {`${cantidad}: ${datos[params.Id].Precios[tipo][cantidad]}`}
                                                        </MDBListGroupItem>
                                                    ))}
                                                </MDBListGroup>
                                            </MDBListGroupItem>
                                        ))}
                                    </MDBListGroup>
                                }
                            </div>
                        </MDBCard>
                    </MDBCol>
                    <br />
                    <MDBBtn size='lg' rounded className="m-5 mx-auto" color='success' href="https://api.whatsapp.com/send/?phone=573147646339&text=Hola%2C+quiero+saber+m%C3%A1s+sobre+sus+donitas+%EF%BF%BD&type=phone_number&app_absent=0">
                        <MDBIcon fab icon='whatsapp' />
                        Pedir Ahora
                    </MDBBtn>
                </MDBRow>
            </MDBContainer>
            <Footer />
        </>
    );
}

const VewImagen = () => {
    const [datos, setDatos] = useState([]);
    const params = useParams();

    useEffect(() => {
        // Simulando una carga asíncrona
        // Reemplaza esto con tu lógica de carga de datos real
        // Ejemplo: const response = await fetch("ruta/del/archivo/output.json");
        // const data = await response.json();
        const data = Json; // Simulación de datos, reemplázalo con tu lógica real
        setDatos(Object.values(data));
    }, [params.Id]); // Asegúrate de incluir params.Id en las dependencias del useEffect

    if (!datos[params.Id] || !params.Id) {
        return <div>Cargando datos...</div>;
    } else {
        return <MDBCardImage
            src={require(datos[params.Id].Imagen + "")}
            alt={"Img/" + datos[params.Id].Imagen + "/"}
            height={500}
            className='square border border-2 p-2'
        />
    }
}